import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../common/html/checkbox'
import { Element } from '../../../common/html/element'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { formatText } from '../../../helpers/value'
import { COMPONENTS } from '../../../routers/constants'
import {
  changeCheckboxTable,
  selectCheckboxFollow,
  selectDataTableFollowingList,
} from '../store/slice'

export const CustomTdTitleFollowingList = ({ item, rowId }) => {
  const dispatch = useDispatch()

  const dataTable = useSelector(selectDataTableFollowingList)
  const isCheck = useSelector(selectCheckboxFollow(['listIdsSelected', rowId]))
  const listCheckbox = useSelector(selectCheckboxFollow(['listIdsSelected']))
  const isCanNavigate = !Object.values(listCheckbox).some(Boolean)

  const handleCheckbox = (value) => {
    dispatch(
      changeCheckboxTable({
        path: ['listIdsSelected', rowId],
        data: value,
      }),
    )
  }

  return (
    <div
      className="dFlex alignItemsCenter"
      onClick={() => {
        if (!isCanNavigate) {
          handleCheckbox(!isCheck)
        }
      }}
      style={{ padding: '4px 12px' }}
    >
      <div style={{ paddingRight: 26 }}>
        <Checkbox
          styleIcon={{ fontSize: 13 }}
          onChange={handleCheckbox}
          checked={isCheck}
        />
      </div>
      {isCanNavigate ? (
        <Element
          elementName="a"
          href={`${COMPONENTS.companyAnalysis.components.summary.route}?organizationId=${dataTable[rowId]?.organizationId}`}
          target="_blank"
          style={{ overflowWrap: 'break-word', color: '#2C73E8' }}
        >
          <TextEllipsisStaticLine
            text={formatText(item)}
            lineClamp={2}
            tooltipStyle={{ minWidth: 200 }}
            isI18n={false}
          />
        </Element>
      ) : (
        <TextEllipsisStaticLine
          text={formatText(item)}
          lineClamp={2}
          tooltipStyle={{ minWidth: 200 }}
          isI18n={false}
          appendStyle={{ cursor: 'pointer', color: '#2C73E8' }}
        />
      )}
    </div>
  )
}
